import React, { useState } from "react";
import {
  Box,
  Button,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import PersonaAutocomplete from "./PersonaAutocomplete";
import DocumentSelectorModal from "./DocumentSelectorModal";

export default function RemissionGuideInfo({
  data,
  onChange,
  onDocumentSelected,
  mobile = false,
}) {
  const [open, setOpen] = useState(false);

  const hasDocument = Boolean(data.documento_relacionado_id);

  return (
    <Box sx={{ width: "100%" }}>
      <Paper
        sx={{
          p: mobile ? 1.5 : 2,
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          bgcolor: "#fafafa",
        }}
      >
        <Typography sx={{ fontWeight: 800, color: "#333", mb: 1.5 }}>
          Información de guía de remisión
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          <Button
            variant="contained"
            onClick={() => setOpen(true)}
            sx={{ bgcolor: "#1565C0", alignSelf: mobile ? "stretch" : "flex-start" }}
          >
            Seleccionar documento sustento
          </Button>

          {hasDocument && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <TextField
                label="Documento sustento"
                value={data.documento_relacionado_numero || ""}
                InputProps={{ readOnly: true }}
                fullWidth={mobile}
                sx={{ minWidth: mobile ? "100%" : 350 }}
              />
              <TextField
                label="Clave de acceso"
                value={data.documento_relacionado_clave_acceso || ""}
                InputProps={{ readOnly: true }}
                fullWidth
              />
            </Box>
          )}

          <TextField
            label="Motivo de traslado"
            value={data.guia_motivo_traslado || ""}
            onChange={(e) => onChange?.({ guia_motivo_traslado: e.target.value })}
            fullWidth
          />

          <TextField
            label="Punto de partida"
            value={data.guia_punto_partida || ""}
            onChange={(e) => onChange?.({ guia_punto_partida: e.target.value })}
            fullWidth
          />

          <TextField
            label="Punto de llegada"
            value={data.guia_punto_llegada || ""}
            onChange={(e) => onChange?.({ guia_punto_llegada: e.target.value })}
            fullWidth
          />

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: mobile ? "1fr" : "1fr 1fr",
              gap: 1.5,
            }}
          >
            <TextField
              label="Fecha inicio traslado"
              value={data.guia_fecha_inicio || ""}
              onChange={(e) => onChange?.({ guia_fecha_inicio: e.target.value })}
              placeholder="dd/mm/aaaa"
              inputProps={{ maxLength: 10 }}
              fullWidth
            />

            <TextField
              label="Fecha fin traslado"
              value={data.guia_fecha_fin || ""}
              onChange={(e) => onChange?.({ guia_fecha_fin: e.target.value })}
              placeholder="dd/mm/aaaa"
              inputProps={{ maxLength: 10 }}
              fullWidth
            />
          </Box>

          <Box>
            <Typography sx={{ fontWeight: 700, color: "#333", mb: 0.75 }}>
              Transportista
            </Typography>
            <PersonaAutocomplete
              value={data.guia_transportista}
              tipoDocumento="PROVEEDOR"
              onChange={(persona) => onChange?.({ guia_transportista: persona })}
              mobile={mobile}
            />
          </Box>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: mobile ? "1fr" : "1fr 1fr",
              gap: 1.5,
            }}
          >
            <TextField
              label="Placa"
              value={data.guia_placa || ""}
              onChange={(e) => onChange?.({ guia_placa: e.target.value.toUpperCase() })}
              fullWidth
            />

            <TextField
              label="Ruta"
              value={data.guia_ruta || ""}
              onChange={(e) => onChange?.({ guia_ruta: e.target.value })}
              fullWidth
            />
          </Box>
        </Box>
      </Paper>

      <DocumentSelectorModal
        open={open}
        onClose={() => setOpen(false)}
        persona={data.persona}
        title="Seleccionar documento sustento"
        tipo="FACTURA"
        endpoint="/facturas/documentos-relacionados/facturas-cliente/"
        detailEndpoint="/facturas/documentos-relacionados/detalle-factura/"
        onSelected={onDocumentSelected}
      />
    </Box>
  );
}